import { ApolloClient, ApolloLink, InMemoryCache } from "@apollo/client"
import { onError } from "@apollo/client/link/error"
import { createUploadLink } from "apollo-upload-client"

// See also https://github.com/apollographql/GitHunt-React/blob/master/src/client.js
const clientFor = (endpoint = "/graphql") =>
  new ApolloClient({
    link: ApolloLink.from([
      onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
          graphQLErrors.map(({ message, locations, path }) => {
            console.error(
              `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
            )
          })
        }

        if (networkError && networkError.statusCode === 401) {
          // console.warn(`[Network error]: ${networkError}`)
          window.location.replace("/dashboard")
        }
      }),
      createUploadLink({
        uri: endpoint,
        credentials: "same-origin",
        headers: {
          "X-CSRF-Token": document
            .querySelector("meta[name=csrf-token]")
            .getAttribute("content"),
        },
      }),
    ]),
    cache: new InMemoryCache(),
  })

export default clientFor
